import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@app/shared'
import { LoginComponent } from './pages/login/login.component'
import { LogoutComponent } from './pages/logout/logout.component'
import { SessionRoutingModule } from './session-routing.module'
import { RegisterComponent } from './pages/register/register.component'
import { LostPasswordComponent } from './pages/lost-password/lost-password.component'
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component'
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component'

@NgModule({
  providers: [],
  declarations: [LoginComponent, LogoutComponent, RegisterComponent, LostPasswordComponent, ConfirmEmailComponent, ResetPasswordComponent],
  imports: [CommonModule, SessionRoutingModule, SharedModule],
})
export class SessionModule {}
